import React, { FC } from 'react';
import * as MESSAGES from 'constants/messages';
import { PROFILE_FIELDS_MAX_LENGTH } from 'constants/profile';
import { ProfileFormRegister } from 'types/profile';
import { TextInput } from 'components/atoms';
import { Field } from 'components/molecules';

type FirstNameFormFieldProps = {
  error: string | undefined;
  register: ProfileFormRegister<'firstName'>;
};

const FirstNameFormField: FC<FirstNameFormFieldProps> = props => {
  const { error, register } = props;
  return (
    <Field label={MESSAGES.PROFILE.FIELD.FIRST_NAME.LABEL} required locked>
      <TextInput
        enterKeyHint="enter"
        name="firstName"
        error={error}
        maxLength={PROFILE_FIELDS_MAX_LENGTH.FIRST_NAME}
        placeholder={MESSAGES.PROFILE.FIELD.FIRST_NAME.PLACEHOLDER}
        aria-label={MESSAGES.PROFILE.FIELD.FIRST_NAME.LABEL}
        ref={register}
      />
    </Field>
  );
};

export default FirstNameFormField;
